import { render, staticRenderFns } from "./InviteExternalUserForm.vue?vue&type=template&id=3edbfdae"
import script from "./InviteExternalUserForm.vue?vue&type=script&lang=js"
export * from "./InviteExternalUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports